"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.giftUnexpire = exports.updateGiftQuantity = exports.setGiftProductOptionsFailed = exports.setGiftProductOptionsSuccess = exports.setGiftProductOptions = exports.giftVerifyAvailableContactReset = exports.giftVerifyAvailableContactFailed = exports.giftVerifyAvailableContactSuccess = exports.giftVerifyAvailableContact = exports.giftResetRequest = exports.giftCancelFail = exports.giftCancelSuccess = exports.giftCancelRequest = exports.giftExpireFail = exports.giftExpireSuccess = exports.giftExpireRequest = exports.saveGiftVideoMessageCleanError = exports.giftSetFullResearchFail = exports.giftSetFullResearchSuccess = exports.giftSetFullResearch = exports.waitForInstantResearchCancel = exports.waitForInstantResearchComplete = exports.waitForInstantResearchStart = exports.giftSetSendAsFail = exports.giftSetSendAsSuccess = exports.giftSetSendAsRequest = exports.giftSetGiftActionsFail = exports.giftSetGiftActionsSuccess = exports.giftSetGiftActionsRequest = exports.giftDiscardFail = exports.giftDiscardSuccess = exports.giftDiscardRequest = exports.giftEditStep = exports.giftClearError = exports.giftSetVideoMessageFail = exports.giftSetVideoMessageSuccess = exports.giftSetVideoMessage = exports.giftSendReset = exports.giftSendFail = exports.giftSendSuccess = exports.giftSendRequest = exports.selectTemplate = exports.giftSetProductFail = exports.giftSetProductSuccess = exports.selectProduct = exports.selectExchangeProduct = exports.giftRefreshFail = exports.giftRefreshSuccess = exports.giftRefreshRequest = exports.giftLoadFail = exports.giftLoadSuccess = exports.giftLoadRequest = exports.giftCreateFail = exports.giftCreateSuccess = exports.giftCreateRequest = exports.giftCreateReset = void 0;

var _utils = require("@alycecom/utils");

var _constants = require("../../constants");

var _gift = require("./gift.types");

var giftCreateReset = function giftCreateReset() {
  return {
    type: _gift.GIFT_CREATE_RESET
  };
};

exports.giftCreateReset = giftCreateReset;

var giftCreateRequest = function giftCreateRequest(_ref) {
  var contactId = _ref.contactId,
      campaignId = _ref.campaignId,
      product = _ref.product,
      sfContactId = _ref.sfContactId,
      sfLeadId = _ref.sfLeadId;
  return {
    type: _gift.GIFT_CREATE_REQUEST,
    payload: {
      contactId,
      campaignId,
      product,
      sfContactId,
      sfLeadId
    }
  };
};

exports.giftCreateRequest = giftCreateRequest;

var giftCreateSuccess = function giftCreateSuccess(gift) {
  return {
    type: _gift.GIFT_CREATE_SUCCESS,
    payload: gift
  };
};

exports.giftCreateSuccess = giftCreateSuccess;

var giftCreateFail = function giftCreateFail(error) {
  return {
    type: _gift.GIFT_CREATE_FAIL,
    payload: error
  };
};

exports.giftCreateFail = giftCreateFail;

var giftLoadRequest = function giftLoadRequest(giftId) {
  return {
    type: _gift.GIFT_CREATE_LOAD_REQUEST,
    payload: giftId
  };
};

exports.giftLoadRequest = giftLoadRequest;

var giftLoadSuccess = function giftLoadSuccess(gift) {
  return {
    type: _gift.GIFT_CREATE_LOAD_SUCCESS,
    payload: gift
  };
};

exports.giftLoadSuccess = giftLoadSuccess;

var giftLoadFail = function giftLoadFail(error) {
  return {
    type: _gift.GIFT_CREATE_LOAD_FAIL,
    payload: error
  };
};

exports.giftLoadFail = giftLoadFail;

var giftRefreshRequest = function giftRefreshRequest(giftId, template) {
  return {
    type: _gift.GIFT_REFRESH_LOAD_REQUEST,
    payload: {
      giftId,
      template
    }
  };
};

exports.giftRefreshRequest = giftRefreshRequest;

var giftRefreshSuccess = function giftRefreshSuccess(gift) {
  return {
    type: _gift.GIFT_REFRESH_LOAD_SUCCESS,
    payload: gift
  };
};

exports.giftRefreshSuccess = giftRefreshSuccess;

var giftRefreshFail = function giftRefreshFail(error) {
  return {
    type: _gift.GIFT_REFRESH_LOAD_FAIL,
    payload: error
  };
};

exports.giftRefreshFail = giftRefreshFail;

var selectExchangeProduct = function selectExchangeProduct(giftId, product) {
  return {
    type: _gift.GIFT_CREATE_SELECT_EXCHANGE_PRODUCT,
    payload: {
      giftId,
      product
    }
  };
};

exports.selectExchangeProduct = selectExchangeProduct;

var selectProduct = function selectProduct(giftId, productId) {
  return {
    type: _gift.GIFT_CREATE_SELECT_PRODUCT,
    payload: {
      giftId,
      productId
    }
  };
};

exports.selectProduct = selectProduct;

var giftSetProductSuccess = function giftSetProductSuccess(gift) {
  return {
    type: _gift.GIFT_SET_PRODUCT_SUCCESS,
    payload: gift
  };
};

exports.giftSetProductSuccess = giftSetProductSuccess;

var giftSetProductFail = function giftSetProductFail(error) {
  return {
    type: _gift.GIFT_SET_PRODUCT_FAIL,
    payload: error
  };
};

exports.giftSetProductFail = giftSetProductFail;

var selectTemplate = function selectTemplate(template) {
  return {
    type: _gift.GIFT_CREATE_SELECT_TEMPLATE,
    payload: template
  };
};

exports.selectTemplate = selectTemplate;

var giftSendRequest = function giftSendRequest(giftId) {
  var scheduleAt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var quantity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.DEFAULT_GIFT_QUANTITY;
  return {
    type: _gift.GIFT_CREATE_SEND_REQUEST,
    payload: {
      giftId,
      scheduleAt,
      quantity
    }
  };
};

exports.giftSendRequest = giftSendRequest;

var giftSendSuccess = function giftSendSuccess(gift) {
  return {
    type: _gift.GIFT_CREATE_SEND_SUCCESS,
    payload: gift
  };
};

exports.giftSendSuccess = giftSendSuccess;

var giftSendFail = function giftSendFail(error) {
  return {
    type: _gift.GIFT_CREATE_SEND_FAIL,
    payload: error
  };
};

exports.giftSendFail = giftSendFail;

var giftSendReset = function giftSendReset() {
  return {
    type: _gift.GIFT_CREATE_SEND_RESET
  };
};

exports.giftSendReset = giftSendReset;

var giftSetVideoMessage = function giftSetVideoMessage(_ref2) {
  var giftId = _ref2.giftId,
      type = _ref2.type,
      videoUrl = _ref2.videoUrl,
      vidyardImage = _ref2.vidyardImage,
      vidyardVideo = _ref2.vidyardVideo,
      _ref2$isReady = _ref2.isReady,
      isReady = _ref2$isReady === void 0 ? false : _ref2$isReady;
  return {
    type: _gift.GIFT_SET_VIDEO_MESSAGE_REQUEST,
    payload: {
      giftId,
      type,
      videoUrl,
      vidyardImage,
      vidyardVideo,
      isReady
    }
  };
};

exports.giftSetVideoMessage = giftSetVideoMessage;

var giftSetVideoMessageSuccess = function giftSetVideoMessageSuccess(gift) {
  return {
    type: _gift.GIFT_SET_VIDEO_MESSAGE_SUCCESS,
    payload: gift
  };
};

exports.giftSetVideoMessageSuccess = giftSetVideoMessageSuccess;

var giftSetVideoMessageFail = function giftSetVideoMessageFail(error) {
  return {
    type: _gift.GIFT_SET_VIDEO_MESSAGE_FAIL,
    payload: error
  };
};

exports.giftSetVideoMessageFail = giftSetVideoMessageFail;

var giftClearError = function giftClearError(errorKey) {
  return {
    type: _gift.GIFT_CREATE_CLEAR_ERROR,
    payload: errorKey
  };
};

exports.giftClearError = giftClearError;

var giftEditStep = function giftEditStep(step) {
  return {
    type: _gift.GIFT_CREATE_EDIT_STEP,
    payload: step
  };
};

exports.giftEditStep = giftEditStep;

var giftDiscardRequest = function giftDiscardRequest(giftId) {
  return {
    type: _gift.GIFT_DISCARD_REQUEST,
    payload: giftId
  };
};

exports.giftDiscardRequest = giftDiscardRequest;

var giftDiscardSuccess = function giftDiscardSuccess(giftId) {
  return {
    type: _gift.GIFT_DISCARD_SUCCESS,
    payload: giftId
  };
};

exports.giftDiscardSuccess = giftDiscardSuccess;

var giftDiscardFail = function giftDiscardFail(error) {
  return {
    type: _gift.GIFT_DISCARD_FAIL,
    payload: error
  };
};

exports.giftDiscardFail = giftDiscardFail;

var giftSetGiftActionsRequest = function giftSetGiftActionsRequest(_ref3) {
  var giftId = _ref3.giftId,
      giftActionsId = _ref3.giftActionsId,
      prospect = _ref3.prospect;
  return {
    type: _gift.GIFT_SET_GIFT_ACTIONS_REQUEST,
    payload: {
      giftId,
      giftActionsId,
      prospect
    }
  };
};

exports.giftSetGiftActionsRequest = giftSetGiftActionsRequest;

var giftSetGiftActionsSuccess = function giftSetGiftActionsSuccess(gift) {
  return {
    type: _gift.GIFT_SET_GIFT_ACTIONS_SUCCESS,
    payload: gift
  };
};

exports.giftSetGiftActionsSuccess = giftSetGiftActionsSuccess;

var giftSetGiftActionsFail = function giftSetGiftActionsFail(error) {
  return {
    type: _gift.GIFT_SET_GIFT_ACTIONS_FAIL,
    payload: error
  };
};

exports.giftSetGiftActionsFail = giftSetGiftActionsFail;

var giftSetSendAsRequest = function giftSetSendAsRequest(_ref4) {
  var giftId = _ref4.giftId,
      userId = _ref4.userId;
  return {
    type: _gift.GIFT_SET_SEND_AS_REQUEST,
    payload: {
      giftId,
      userId
    }
  };
};

exports.giftSetSendAsRequest = giftSetSendAsRequest;

var giftSetSendAsSuccess = function giftSetSendAsSuccess(gift) {
  return {
    type: _gift.GIFT_SET_SEND_AS_SUCCESS,
    payload: gift
  };
};

exports.giftSetSendAsSuccess = giftSetSendAsSuccess;

var giftSetSendAsFail = function giftSetSendAsFail(error) {
  return {
    type: _gift.GIFT_SET_SEND_AS_FAIL,
    payload: error
  };
};

exports.giftSetSendAsFail = giftSetSendAsFail;

var waitForInstantResearchStart = function waitForInstantResearchStart() {
  return {
    type: _gift.WAIT_FOR_INSTANT_RESEARCH.START
  };
};

exports.waitForInstantResearchStart = waitForInstantResearchStart;

var waitForInstantResearchComplete = function waitForInstantResearchComplete() {
  return {
    type: _gift.WAIT_FOR_INSTANT_RESEARCH.COMPLETE
  };
};

exports.waitForInstantResearchComplete = waitForInstantResearchComplete;

var waitForInstantResearchCancel = function waitForInstantResearchCancel() {
  return {
    type: _gift.WAIT_FOR_INSTANT_RESEARCH.CANCEL
  };
};

exports.waitForInstantResearchCancel = waitForInstantResearchCancel;

var giftSetFullResearch = function giftSetFullResearch(giftId) {
  return {
    type: _gift.SET_FULL_RESEARCH.REQUEST,
    payload: giftId
  };
};

exports.giftSetFullResearch = giftSetFullResearch;

var giftSetFullResearchSuccess = function giftSetFullResearchSuccess(giftId) {
  return {
    type: _gift.SET_FULL_RESEARCH.SUCCESS,
    payload: giftId
  };
};

exports.giftSetFullResearchSuccess = giftSetFullResearchSuccess;

var giftSetFullResearchFail = function giftSetFullResearchFail(giftId) {
  return {
    type: _gift.SET_FULL_RESEARCH.FAIL,
    payload: giftId
  };
};

exports.giftSetFullResearchFail = giftSetFullResearchFail;

var saveGiftVideoMessageCleanError = function saveGiftVideoMessageCleanError(errors) {
  return {
    type: _gift.SAVE_GIFT_VIDEO_MESSAGE_CLEAN_ERROR,
    payload: errors
  };
};

exports.saveGiftVideoMessageCleanError = saveGiftVideoMessageCleanError;

var giftExpireRequest = function giftExpireRequest(giftId) {
  return {
    type: _gift.GIFT_EXPIRE_REQUEST,
    payload: giftId
  };
};

exports.giftExpireRequest = giftExpireRequest;

var giftExpireSuccess = function giftExpireSuccess(gift) {
  return {
    type: _gift.GIFT_EXPIRE_SUCCESS,
    payload: gift
  };
};

exports.giftExpireSuccess = giftExpireSuccess;

var giftExpireFail = function giftExpireFail(error) {
  return {
    type: _gift.GIFT_EXPIRE_FAIL,
    payload: error
  };
};

exports.giftExpireFail = giftExpireFail;

var giftCancelRequest = function giftCancelRequest(giftId) {
  return {
    type: _gift.GIFT_CANCEL_REQUEST,
    payload: giftId
  };
};

exports.giftCancelRequest = giftCancelRequest;

var giftCancelSuccess = function giftCancelSuccess(gift) {
  return {
    type: _gift.GIFT_CANCEL_SUCCESS,
    payload: gift
  };
};

exports.giftCancelSuccess = giftCancelSuccess;

var giftCancelFail = function giftCancelFail(error) {
  return {
    type: _gift.GIFT_CANCEL_FAIL,
    payload: error
  };
};

exports.giftCancelFail = giftCancelFail;

var giftResetRequest = function giftResetRequest() {
  return {
    type: _gift.GIFT_SALES_INTEGRATIONS_RESET
  };
};

exports.giftResetRequest = giftResetRequest;

var giftVerifyAvailableContact = function giftVerifyAvailableContact(email) {
  return {
    type: _gift.GIFT_VERIFY_AVAILABLE_CONTACT_REQUEST,
    payload: {
      email
    }
  };
};

exports.giftVerifyAvailableContact = giftVerifyAvailableContact;

var giftVerifyAvailableContactSuccess = function giftVerifyAvailableContactSuccess(contact) {
  return {
    type: _gift.GIFT_VERIFY_AVAILABLE_CONTACT_SUCCESS,
    payload: contact
  };
};

exports.giftVerifyAvailableContactSuccess = giftVerifyAvailableContactSuccess;

var giftVerifyAvailableContactFailed = function giftVerifyAvailableContactFailed() {
  return {
    type: _gift.GIFT_VERIFY_AVAILABLE_CONTACT_FAILED
  };
};

exports.giftVerifyAvailableContactFailed = giftVerifyAvailableContactFailed;

var giftVerifyAvailableContactReset = function giftVerifyAvailableContactReset() {
  return {
    type: _gift.GIFT_VERIFY_AVAILABLE_CONTACT_RESET
  };
};

exports.giftVerifyAvailableContactReset = giftVerifyAvailableContactReset;

var setGiftProductOptions = function setGiftProductOptions(options) {
  return {
    type: _gift.GIFT_SET_PRODUCT_OPTIONS_REQUEST,
    payload: {
      options
    }
  };
};

exports.setGiftProductOptions = setGiftProductOptions;

var setGiftProductOptionsSuccess = function setGiftProductOptionsSuccess(gift) {
  return {
    type: _gift.GIFT_SET_PRODUCT_OPTIONS_SUCCESS,
    payload: gift
  };
};

exports.setGiftProductOptionsSuccess = setGiftProductOptionsSuccess;

var setGiftProductOptionsFailed = function setGiftProductOptionsFailed() {
  return {
    type: _gift.GIFT_SET_PRODUCT_OPTIONS_FAILED
  };
};

exports.setGiftProductOptionsFailed = setGiftProductOptionsFailed;

var updateGiftQuantity = function updateGiftQuantity(quantity) {
  return {
    type: _gift.GIFT_QUANTITY_UPDATE,
    payload: {
      quantity
    }
  };
};

exports.updateGiftQuantity = updateGiftQuantity;
var prefix = 'COMMON/GIFT';
var giftUnexpire = (0, _utils.createAsyncAction)("".concat(prefix, "/UNEXPIRE"));
exports.giftUnexpire = giftUnexpire;